import { URLS } from "../../Utilities/Maps";

export const isSupportedPage = (path: string) => {
  const urls = [URLS.ROOT, URLS.START, URLS.TEAMS, URLS.UPGRADE];
  return urls.includes(path.split(/(?=\/)/g)[0]);
};
